/**
 * Ryan O'Dowd
 * 2025-05-09
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import 'react-circular-progressbar/dist/styles.css';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const AnimatedRings = (props: AnimatedRingsProps) => {
  const styles = hooks.useStyles(getStyles);

  // @NOTE: strokeWidth is a percentage of the width, not a pixel value
  const versesStrokeWidth = props.width / props.size * 100;
  const lessonsStrokeWidth = props.width / (0.8 * props.size) * 100;
  const peanutsStrokeWidth = props.width / (0.6 * props.size) * 100;

  return (
    <View style={styles.container(props.size)}>
      <CircularProgressbarWithChildren
        value={props.versesLeveledUpFillPercent}
        strokeWidth={versesStrokeWidth}
        styles={buildStyles({
          pathColor: props.versesLeveledUpFillPercent === 100 ? styles.colors.accent : styles.colors.qqq,
          trailColor: styles.colors.primaryDark,
        })}
      >
        <View style={styles.container(0.8 * props.size)}>
          <CircularProgressbarWithChildren
            value={props.lessonsFillPercent}
            strokeWidth={lessonsStrokeWidth}
            styles={buildStyles({
              pathColor: props.lessonsFillPercent === 100 ? styles.colors.accent : styles.colors.qqq,
              trailColor: styles.colors.primaryDark,
            })}
          >
            <View style={styles.container(0.6 * props.size)}>
              <CircularProgressbarWithChildren
                value={props.peanutsFillPercent}
                strokeWidth={peanutsStrokeWidth}
                styles={buildStyles({
                  pathColor: props.peanutsFillPercent === 100 ? styles.colors.accent : styles.colors.qqq,
                  trailColor: styles.colors.primaryDark,
                })}
              >
                {typeof props.children === 'function' ? props.children() : props.children}
              </CircularProgressbarWithChildren>
            </View>
          </CircularProgressbarWithChildren>
        </View>
      </CircularProgressbarWithChildren>
    </View>
  );
};

class AnimatedRingsProps { // @TODO: combine with native
  children: React.ReactNode | (() => React.ReactNode);
  size: number;
  width: number;
  versesLeveledUpFillPercent: number;
  lessonsFillPercent: number;
  peanutsFillPercent: number;
};

export default AnimatedRings;
